import { ref } from 'vue';

export const usePage = opts => {
  const total = ref(0); // 总记录数
  const currentPage = ref(1); // 当前页码
  const pageSize = ref(10); // 每页多少条
  const pagerCount = ref(10); // 最大页码按钮数。超过该值时会折叠

  // 初始化赋值
  if (opts?.currentPage > 0) currentPage.value = opts.currentPage;
  if (opts?.total > -1) total.value = opts.total;
  if (opts?.pageSize > 0) total.value = opts.pageSize;
  if (opts?.pagerCount > 0) total.value = opts.pagerCount;

  const handleCurrentChange = val => {
    console.log('handleCurrentChange:', val);
    currentPage.value = val;
  };

  return {
    total,
    currentPage,
    pageSize,
    pagerCount,
    handleCurrentChange
  };
};
